module.exports = __webpack_public_path__ + "img/DE05188.f0d0eb48.png";